import { Grid } from '@mui/material';

import { FormRichTextField, TEXT_AREA_MAX_LENGTH } from '../../../../../common';
import { CRISIS_PLAN_RICH_TEXT_MIN_HEIGHT } from '../constants';

import type { CrisisPlanRichTextFieldProps } from './types';

export default function CrisisPlanRichTextField({
  formik,
  name,
  label,
  disabled,
  readOnly,
  saveField,
}: CrisisPlanRichTextFieldProps) {
  return (
    <Grid item xs={12}>
      <FormRichTextField
        disabled={disabled}
        formik={formik}
        label={label}
        maxLength={TEXT_AREA_MAX_LENGTH}
        minHeight={CRISIS_PLAN_RICH_TEXT_MIN_HEIGHT}
        name={name}
        onBlur={saveField}
        readOnly={readOnly}
        required
      />
    </Grid>
  );
}
